(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesController', SecurityRolesController);

    SecurityRolesController.$inject = ['SecurityRoles','$scope', '$state','$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider'];

    function SecurityRolesController(SecurityRoles,$scope, $state, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider ) {

        var vm = this;

        vm.securityRoles = [];


        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/security-roles/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                // The returned object has 'email' as property, but the server entity has 'emailAddress'

                // Any values you set on the data object will be passed along as parameters to the server
                //data.access_token = AuthenticationService.getAccessToken();
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
        .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
        .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        }) .withButtons([
                {
                    text: 'Export',
                    extend: "excelHtml5",
                    title:"Nasrac Source Types",
                    action: function (e, dt, node, config) {
                        SecurityRoles.download().$promise
                            .then(function (data) {
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_SecurityRole.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ])
    .withPaginationType('full_numbers')


    .withOption('createdRow', function (row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
    })
    .withOption('saveState', true)
    .withOption('order', [0, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
    .withOption("pageLength", 25);


        vm.dtColumns = [
                      DTColumnBuilder.newColumn('securityRoleName').withTitle('Security Role Name'),
                      DTColumnBuilder.newColumn('securityRoleDesc').withTitle('Security Role Desc'),
                      DTColumnBuilder.newColumn('publicRoleFlag').withTitle('Public Role Flag'),
                      DTColumnBuilder.newColumn('autoAssignFlag').withTitle('Auto Assign Flag')
                ];


    }
})();
